import PropTypes from 'prop-types';
import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import ProductDetails from '../components/shopping/product_details';
import ProductDetailsComments from '../components/shopping/product_details/comments';
import {isEmpty} from 'lodash';

const options = {
  displayName: 'ProductDetailContainer',

  propTypes: {
    product: PropTypes.object.isRequired,
    meta_data: PropTypes.shape({
      meta_title: PropTypes.string,
      meta_description: PropTypes.string
    }),
    analytics: PropTypes.shape({
      url_full: PropTypes.string
    })
  },

  mapStateToProps: (state) => [state, {
    product: state.product,
    meta_data: state.meta_data,
    analytics: state.analytics,
    shoppingNavigation: state.shoppingNavigation
  }],

  shouldDisplayCondensedNav() {
    return true;
  },

  productDetails() {
    return <ProductDetails {...this.props} />;
  },

  contentAboveModules() {
    if (isEmpty(this.props.product)) {
      return null;
    }
    return this.productDetails();
  },

  contentBelowModules() {
    if (isEmpty(this.props.product)) {
      return null;
    }

    return <ProductDetailsComments {...this.props} />;
  },

  shouldDisplayAdhesionAd() {
    return false;
  }
};

export const ProductDetailContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
